import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Moment from 'react-moment';
import * as moment from 'moment';

import { deepEqual } from './../../utils';
import * as lifeEventsTypes from './../lifeEvents.types';

import Duration from './../../Shared/DateTime/Duration';

class LifeEventRow extends Component {
  constructor(props) {
    super(props);

    this.onDeleteClick = this.onDeleteClick.bind(this);
  }
  shouldComponentUpdate(nextProps) {
    return !deepEqual(this.props, nextProps);
  }

  onDeleteClick() {
    this.props.onDelete(String(this.props.event.startedAt));
  }

  render() {
    const { event, isLast } = this.props;

    const duration = isLast ? (moment().valueOf() - event.startedAt) : (event.duration || 0);
    const isFuture = moment().isBefore(event.startedAt);

    return (
      <tr>
        <td style={{ color: (isFuture ? '#F44336' : '#454B4D') }}>
          <Moment format="DD/MM/YYYY HH:mm, ddd">{event.startedAt}</Moment>
          {isLast && (
            <a
              onClick={this.onDeleteClick}
              onKeyPress={this.onDeleteClick}
              role="button"
              tabIndex={0}
            >
              {'  '}<i className="md-icon">delete</i>
            </a>
          )}
        </td>
        <td>
          {lifeEventsTypes.humanizedNames[event.eventType] || 'NÃO IDENTIFICADO'}
          {event.eventType === lifeEventsTypes.types.WEEKLY_REST &&
            <span>{' '}{event.eventMetaHoursSize}h</span>}
          {event.eventType === lifeEventsTypes.types.RECOUPED_WORK &&
            <span>{' '}{Math.floor((event.eventMetaHoursSize || 0)/24)}d</span>}
        </td>
        <td className="align-right">
          {(duration < 0) ? '-' : (
            <Duration ms={duration} as="days" />
          )}
        </td>
        <td className="align-right"><Duration ms={event.accWork || 0} as="days" /></td>
        <td className="align-right"><Duration ms={event.accWeeklyRest || 0} as="days" /></td>
      </tr>
    );
  }
}

LifeEventRow.propTypes = {
  event: PropTypes.object.isRequired,
  isLast: PropTypes.bool,
  onDelete: PropTypes.func.isRequired,
};

LifeEventRow.defaultProps = {
  isLast: false,
};

export default LifeEventRow;



// WEBPACK FOOTER //
// ./src/Driver/DriverLifeEventsPopup/LifeEventRow.js